import { usePaginatedQuery } from 'react-query';
import { listInvitations } from 'src/services/api/invitations';

function useListInvitations(query) {
  return usePaginatedQuery(['invitations', query], (key, query) => listInvitations(query));
}

export default useListInvitations;
